define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/_base/array",
	"csi/html",
	"csi/store/DelayedRequest",
	"csi/utility/validateUtility",
	"csi/xml",
	"./_ComboBoxCheckedMenu",
], function(declare, lang, _, csiArray, html, { DelayedRequestState }, validateUtility, xml, _ComboBoxMenu) {

	return declare(null, {
		acceptsMultipleValues: true,

		addNewItem: false,

		// specify our own drop-down to handle disabled items
		dropDownClass: _ComboBoxMenu,

		_announceOption: function(/*Node*/ node) {
			// Override autocomplete
		},

		_validateEmail: function(val) {
			return validateUtility.isEmailAddress(val);
		},


		_openResultList: function(/*Object*/ results, /*Object*/ query, /*Object*/ options) {
			// DOJO INTERNAL: only autoComplete if one result
			// make sure to compare against real results rather than actions posing as results
			// FIX: don't like doing it this way, but it works; would like to override the dropDown menu
			// with extra action, but ComboBox is too tightly integrated with ComboBox menu
			if (!html.isShown(this.domNode) && !this.extraTextBox) {
				return;
			}

			// wait until results are resolved, or else get javascript error trying to modify results
			if (results.then) {
				results.then(lang.hitch(this, function(res) {
					this._openResultList(res, query, options);
				}));
				return;
			}

			var textValue = this.textbox.value.trim();

			if (this.bScanned) {
				//scan data starts with few special characters that need to be stripped out
				textValue = textValue.replace("\\000026", "");
				this.textbox.value = textValue;
			}


			var filterString = {};
			var filterNonBlankIndex = null;
			var filterBlankIndex = null;
			filterString[this._newItemAttr] = true;
			filterString[this.searchAttr] = textValue;

			this.storeLabel = this.labelAttr || this.searchAttr;

			if (this.store.idProperty == this.storeLabel) {
				this.CLEARVALUE = this._getDefaultClearText();
			}

			// find "blanks" value
			_.some(results, function(val, index) {
				if (val[this.store.idProperty] == xml.VALUE_BLANK) {
					filterBlankIndex = index;
					return val;
				}
			}, this);

			if (filterBlankIndex != null) {
				// move "blanks" value to first even after the array gets sorted with checked values on top
				var filterBlank = results[filterBlankIndex];
				results.splice(filterBlankIndex, 1);
				results.unshift(filterBlank);
			}

			// find "non blanks" value
			_.some(results, function(val, index) {
				if (val[this.store.idProperty] == xml.VALUE_NONBLANK) {
					filterNonBlankIndex = index;
					return val;
				}
			}, this);

			if (filterNonBlankIndex != null) {
				// move "non blanks" value to first even after the array gets sorted with checked values on top
				var filterNonBlank = results[filterNonBlankIndex];
				results.splice(filterNonBlankIndex, 1);
				results.unshift(filterNonBlank);
			}

			if (this.store.isDelayedSearch && this.store.isWaiting) {
				results = results.filter((item) => this.value.includes(item[this.store?.idProperty]));
			}
			if ((this.validateType == null || (this.validateType == "Email" && this._validateEmail(textValue))) && this.addNewItem && textValue != "" && textValue != this.dropDown.previousButton.innerHTML && textValue != this.dropDown.nextButton.innerHTML) {
				if (this.showMatchEntry || !csiArray.containsStrI(_.pluck(results, this.searchAttr).filter(item=>item), textValue)) {
					var newItem = {
						type: "__addNewButton"
					};

					newItem[this.store.idProperty] = textValue;
					newItem[this.searchAttr] = textValue;
					newItem[this.labelAttr] = textValue;

					var filterResult = _.where(results, filterString);
					if (filterResult.length < 1) {
						results.unshift(newItem);
					} else {
						this.showClearField = false;
					}
				} else {
					this.showClearField = false;
				}
			}

			this.dropDown.ref = this;

			var ad = this.store.actionData;
			var n = 1 + (ad ? ad.length : 0);
			var b = results.length > n;

			if (this._prev_key_backspace) {
				this.inherited(arguments);
			} else {
				this._prev_key_backspace = b;
				this.inherited(arguments);
				this._prev_key_backspace = false;
			}

			// for auto selecting a new value add option
			if (_.contains(_.pluck(results, 'type'), "__addNewButton")) {
				this.dropDown.selectNextNode();
			}
			// if going from one announced result to multiple results, then reset valueNode to real _lastInput
			if (b && this._csiPrefix) {
				this.focusNode.value = this._lastInput;
				this._csiPrefix = null;
			}

			const {enterEvent} = this;
			this.enterEvent = null;

			if (this.bScanned) {
				//reset attributes on new scanned data and call an enter key event
				this.bScanned = false;
				this._onKey(enterEvent);
				this._onBlur();
			}
		},

		postCreate: function() {
			// sets the initial display value of the widget if no default values are given
			this.inherited(arguments);
			this.textbox.value = "";
			this._setPlaceholderValue();
		}
	});
});
